module.exports = __webpack_public_path__ + "static/img/5.10c8177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/4/5.png
// module id = d1PT
// module chunks = 0